import styled from "styled-components"

export const TeamContainer = styled.div`
  background-color: #0e4b72;
  padding: 60px 30px;
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: cover;

  h3 {
    color: ${props => props.theme.colors.white};
    padding-left: 15px;
    margin-bottom: 32px;
  }
`
export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;

  .slick-slide {
    padding: 0 16px;
    box-sizing: border-box;
  }

  .slick-dots {
    position: relative;
    top: 0;
    margin-top: 32px;
    li {
      button:before {
        color: ${props => props.theme.colors.white};
      }
    }
    li.slick-active button:before {
      color: ${props => props.theme.colors.white};
    }
  }
`
export const SlideCard = styled.div`
  background-color: ${props => props.theme.colors.white};
  padding: 12px;
  min-height: 357px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  h6 {
    margin-top: 16px;
    color: ${props => props.theme.colors.darkBlue};
    font-size: 15px;
  }
  p {
    color: ${props => props.theme.colors.brightBlue};
  }
  button {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border: none;
    background-color: ${props => props.theme.colors.white};
    padding: 0;
    margin-top: 16px;
    p {
      flex: 1;
    }
    p:first-child {
      text-align: left;
    }
    p:last-child {
      text-align: right;
    }
  }
`
export const SlideContent = styled.div`
  height: 100%;
  img {
    width: 100%;
  }
`

export const SlideButton = styled.div`
  height: 100%;
`
